export default __webpack_public_path__ + "static/media/our-team-bg2.eb84364f.jpg";